import React from 'react'
import styled from 'styled-components'
import { getTheme, toWidth } from 'helpers'
import Loader from 'components/Loader'
import AspectRatioImage, { AspectRatioImageContainer } from 'components/AspectRatioImage'
import svgPlay from 'assets/svg/icon-play.svg'

export default ({ loading, width, video, onClick }) =>
  loading ? <Loader /> : (
    <VideoLink onClick={onClick}>
      <CoverImageContainer>
        <AspectRatioImage src={toWidth(video.imagePath, 300)} />
        <IconPlayWrapper>
          <img alt='' src={svgPlay} />
        </IconPlayWrapper>
      </CoverImageContainer>
      <VideoName>{video.name}</VideoName>
      <Duration>{Math.floor(video.duration / 60)} นาที {video.duration % 60} วินาที</Duration>
    </VideoLink>
  )

const VideoLink = styled.div`
  margin-bottom: 10px;
  position: relative;
  cursor: pointer;
  transition: opacity 0.3s ease;
  &:hover { opacity: 0.8; }
`
const CoverImageContainer = styled(AspectRatioImageContainer)`
  padding-bottom: 100%;
  margin-bottom: 5px;
  cursor: pointer;
  transition: opacity 0.3s ease;
`
const IconPlayWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 1;
  text-align: center;
  > img {
    width: 30px;
    height: 30px;
    margin-top: calc(50% - 15px);
  }
`
const VideoName = styled.div`
  font-family: ${getTheme`font1`};
  font-size: 14px;
  word-wrap: break-word;
  line-height: 20px;
  max-height: 40px;
  overflow: hidden;
  color: black;
  clear: both;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`
const Duration = styled.div`
  font-family: ${getTheme`font1`};
  font-size: 14px;
  line-height: 20px;
  color: #767676;
  clear: both;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/components/VideoItem.js